(function () {
  'use strict';

  var widgetSelector = '.reputon-google-reviews-widget[data-type="carousel_static_plate"]';
  var reducedMotionQuery = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };
  var states = [];
  var startupObserver = null;
  var startupTimer = 0;

  function setPausedState(state) {
    if (!state.widget || !state.widget.isConnected) return;

    var paused = !state.visible || document.hidden || reducedMotionQuery.matches;
    state.widget.setAttribute('data-kk-motion-in-view', state.visible ? 'true' : 'false');
    state.widget.setAttribute('data-kk-motion-paused', paused ? 'true' : 'false');
  }

  function updateAll() {
    states = states.filter(function (state) {
      if (!state.widget || !state.widget.isConnected) {
        if (state.observer) state.observer.disconnect();
        return false;
      }

      setPausedState(state);
      return true;
    });
  }

  function initWidget(widget) {
    if (!widget || widget.dataset.kkMotionController === 'true') return;

    var state = {
      widget: widget,
      visible: !('IntersectionObserver' in window),
      observer: null
    };

    widget.dataset.kkMotionController = 'true';
    states.push(state);

    if ('IntersectionObserver' in window) {
      state.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== widget) return;
          state.visible = entry.isIntersecting && entry.intersectionRatio > 0;
          setPausedState(state);
        });
      }, { threshold: [0, 0.01] });
      state.observer.observe(widget);
    }

    setPausedState(state);
  }

  function initAll(scope) {
    var context = scope || document;

    if (context.matches && context.matches(widgetSelector)) {
      initWidget(context);
    }
    if (context.querySelectorAll) {
      context.querySelectorAll(widgetSelector).forEach(initWidget);
    }
  }

  function stopStartupObserver() {
    if (startupObserver) {
      startupObserver.disconnect();
      startupObserver = null;
    }
    if (startupTimer) {
      window.clearTimeout(startupTimer);
      startupTimer = 0;
    }
  }

  function watchForWidget() {
    initAll(document);
    if (document.querySelector(widgetSelector)) {
      stopStartupObserver();
      return;
    }
    if (!('MutationObserver' in window)) return;
    if (startupObserver) return;

    startupObserver = new MutationObserver(function () {
      initAll(document);
      if (document.querySelector(widgetSelector)) stopStartupObserver();
    });
    startupObserver.observe(document.documentElement, { childList: true, subtree: true });
    startupTimer = window.setTimeout(stopStartupObserver, 15000);
  }

  document.addEventListener('visibilitychange', updateAll);

  if (reducedMotionQuery.addEventListener) {
    reducedMotionQuery.addEventListener('change', updateAll);
  } else if (reducedMotionQuery.addListener) {
    reducedMotionQuery.addListener(updateAll);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
    if (!document.querySelector(widgetSelector)) watchForWidget();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    states = states.filter(function (state) {
      if (!event.target.contains(state.widget)) return true;
      if (state.observer) state.observer.disconnect();
      return false;
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForWidget, { once: true });
  } else {
    watchForWidget();
  }
}());
